<div class="offsite-form-container" [class.with-sidebar]="showAreaB && offsiteConfig.form_active" [class.theme-goa]="isGoaTheme">
  <!-- Full-screen loader overlay while loading form data -->
  <div class="form-loader-container" *ngIf="isLoadingFormData || isLoadingConfig">
    <div class="lds-default">
      <div></div><div></div><div></div><div></div>
      <div></div><div></div><div></div><div></div>
      <div></div><div></div><div></div><div></div>
    </div>
  </div>

  <!-- Form Closed State -->
  <div class="form-closed-container" *ngIf="!isLoadingConfig && !offsiteConfig.form_active">
    <div class="form-main form-closed-shell">
      <div class="form-header form-closed-header" [style.--goa-hero-bg]="offsiteConfig.banner_image_url ? 'url(' + offsiteConfig.banner_image_url + ')' : 'none'">
        <div class="header-content">
          <div class="header-badge">{{ isGoaTheme ? 'Gentari India Offsite' : 'Gentari India Registration Form' }}</div>
          <h1>{{ isGoaTheme ? 'Gentari India Offsite ' + offsiteYear + ' Goa' : 'Gentari India Offsite ' + offsiteYear + ' Registration' }}</h1>

          <div class="goa-hero-meta" *ngIf="isGoaTheme">
            <span>{{ destinationCity }}</span>
            <span *ngIf="offsiteConfig.offsite_start && offsiteConfig.offsite_end">
              {{ formatConfigDate(offsiteConfig.offsite_start) }} &ndash; {{ formatConfigDate(offsiteConfig.offsite_end) }}
            </span>
          </div>
        </div>
      </div>

      <div class="form-banner" *ngIf="offsiteConfig.banner_image_url && !isGoaTheme">
        <img [src]="offsiteConfig.banner_image_url" alt="Offsite {{ offsiteYear }} banner" class="form-banner-img">
      </div>

      <div class="form-content form-closed-content">
        <div class="form-section form-closed-card" role="status" aria-live="polite">
          <div class="section-header">
            <div class="section-number form-closed-icon" aria-hidden="true"></div>
            <div>
              <h2 class="section-title">Registration Closed</h2>
              <p class="section-subtitle">The Offsite {{ offsiteYear }} registration form is currently not accepting submissions.</p>
            </div>
          </div>

          <div class="important-notice form-closed-notice">
            <div class="notice-icon warning">!</div>
            <p>
              <strong>Submissions are stopped.</strong>
              The registration window is closed for now, so new responses cannot be saved or submitted.
            </p>
          </div>

          <div class="employee-info-grid form-closed-details">
            <div class="info-item" *ngIf="offsiteConfig.form_deadline">
              <label>Closed After</label>
              <span class="info-value">{{ formatConfigDate(offsiteConfig.form_deadline) }}</span>
            </div>
            <div class="info-item">
              <label>Current Status</label>
              <span class="info-value">Submissions stopped</span>
            </div>
            <div class="info-item" *ngIf="offsiteConfig.form_location">
              <label>Destination</label>
              <span class="info-value">{{ offsiteConfig.form_location }}</span>
            </div>
            <div class="info-item" *ngIf="offsiteConfig.offsite_start && offsiteConfig.offsite_end">
              <label>Event Dates</label>
              <span class="info-value">
                {{ formatConfigDate(offsiteConfig.offsite_start) }} - {{ formatConfigDate(offsiteConfig.offsite_end) }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="!isLoadingConfig && offsiteConfig.form_active">
  <!-- Mobile Top Bar (visible only on mobile) -->
  <div class="mobile-top-bar">
    <div class="mobile-brand">
      <span class="brand-icon">&#9733;</span>
      <span class="brand-text">{{ isGoaTheme ? 'Gentari India Offsite Goa ' + offsiteYear : 'Gentari India Offsite ' + offsiteYear }}</span>
    </div>
    <div class="mobile-step-badge" *ngIf="offsiteForm.get('attendance')?.value === 'Yes'">
      {{ completedSections }}/4
    </div>
  </div>

  <!-- Mobile Stepper Nav (visible only on mobile when attendance=Yes) -->
  <div class="mobile-stepper" *ngIf="offsiteForm.get('attendance')?.value === 'Yes'">
    <div class="stepper-track">
      <div class="stepper-progress" [style.width]="progressPercent + '%'"></div>
    </div>
    <div class="stepper-steps">
      <button type="button" class="stepper-step"
        [class.active]="activeSection === 'attendance'"
        [class.completed]="sectionComplete.attendance"
        (click)="scrollToSection('area-a')">
        <span class="step-dot">1</span>
        <span class="step-label">Attendance</span>
      </button>
      <button type="button" class="stepper-step"
        [class.active]="activeSection === 'preferences'"
        [class.completed]="sectionComplete.preferences"
        (click)="scrollToSection('area-b')">
        <span class="step-dot">2</span>
        <span class="step-label">Preferences</span>
      </button>
      <button type="button" class="stepper-step"
        [class.active]="activeSection === 'accommodation'"
        [class.completed]="sectionComplete.accommodation"
        (click)="scrollToSection('area-c')">
        <span class="step-dot">3</span>
        <span class="step-label">Room</span>
      </button>
      <button type="button" class="stepper-step"
        [class.active]="activeSection === 'travel'"
        [class.completed]="sectionComplete.travel"
        (click)="scrollToSection('area-d')">
        <span class="step-dot">4</span>
        <span class="step-label">Travel</span>
      </button>
    </div>
  </div>

  <!-- Desktop Sidebar Navigation -->
  <div class="form-sidebar" *ngIf="offsiteForm.get('attendance')?.value === 'Yes'">
    <div class="sidebar-header">
      <div class="sidebar-brand">
        <span class="sidebar-brand-icon">&#9733;</span>
        <div>
          <h2>Gentari Offsite {{ offsiteYear }}</h2>
          <p class="description">{{ isGoaTheme ? 'Registration Portal' : 'Registration Portal' }}</p>
        </div>
      </div>
    </div>

    <nav class="sidebar-nav" role="tablist">
      <button type="button"
        class="nav-item" 
        [class.active]="activeSection === 'attendance'"
        [class.completed]="sectionComplete.attendance"
        (click)="scrollToSection('area-a')">
        <span class="nav-step-number">1</span>
        <div class="nav-text">
          <span class="nav-title">Attendance</span>
          <span class="nav-subtitle">Confirm your participation</span>
        </div>
      </button>
      
      <button type="button"
        class="nav-item" 
        [class.active]="activeSection === 'preferences'"
        [class.completed]="sectionComplete.preferences"
        (click)="scrollToSection('area-b')">
        <span class="nav-step-number">2</span>
        <div class="nav-text">
          <span class="nav-title">Preferences</span>
          <span class="nav-subtitle">Meal & ID details</span>
        </div>
      </button>
      
      <button type="button"
        class="nav-item" 
        [class.active]="activeSection === 'accommodation'"
        [class.completed]="sectionComplete.accommodation"
        (click)="scrollToSection('area-c')">
        <span class="nav-step-number">3</span>
        <div class="nav-text">
          <span class="nav-title">Accommodation</span>
          <span class="nav-subtitle">Room type selection</span>
        </div>
      </button>
      
      <button type="button"
        class="nav-item" 
        [class.active]="activeSection === 'travel'"
        [class.completed]="sectionComplete.travel"
        (click)="scrollToSection('area-d')">
        <span class="nav-step-number">4</span>
        <div class="nav-text">
          <span class="nav-title">Travel</span>
          <span class="nav-subtitle">City preferences</span>
        </div>
      </button>
    </nav>

    <div class="sidebar-footer">
      <!-- Deadline Countdown Timer -->
      <div class="deadline-timer" [class.timer-urgent]="timerUrgent" [class.timer-expired]="timerExpired">
        <div class="deadline-label">
          <span class="deadline-icon">&#9201;</span>
          <span>Registration Deadline</span>
        </div>
        <div class="timer-display" *ngIf="!timerExpired">
          {{ timerDisplay }}
        </div>
        <div class="timer-expired-msg" *ngIf="timerExpired">
          Deadline Passed
        </div>
        <div class="timer-deadline-date">{{ deadlineDateLabel }}</div>
      </div>

      <div class="progress-info">
        <span class="progress-label">Progress</span>
        <span class="progress-percentage">{{ progressPercent }}%</span>
      </div>
      <div class="progress-bar">
        <div class="progress-fill" [style.width]="progressPercent + '%'"></div>
      </div>
      <div class="step-indicator">{{ completedSections }} of 4 sections complete</div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="form-main">
    <div class="form-header" [style.--goa-hero-bg]="offsiteConfig.banner_image_url ? 'url(' + offsiteConfig.banner_image_url + ')' : 'none'">
      <div class="header-content">
        <div class="header-badge">{{ isGoaTheme ? 'Gentari India Offsite' : 'Gentari India Registration Form' }}</div>
        <h1>{{ isGoaTheme ? 'Gentari India Offsite ' + offsiteYear + ' Goa' : 'Gentari India Offsite ' + offsiteYear + ' Registration' }}</h1>

        <div class="goa-hero-meta" *ngIf="isGoaTheme">
          <span>{{ destinationCity }}</span>
          <span *ngIf="offsiteConfig.offsite_start && offsiteConfig.offsite_end">
            {{ formatConfigDate(offsiteConfig.offsite_start) }} &ndash; {{ formatConfigDate(offsiteConfig.offsite_end) }}
          </span>
          <!-- <span *ngIf="offsiteConfig.form_deadline">Deadline {{ formatConfigDate(offsiteConfig.form_deadline) }}</span> -->
        </div>
      </div>
    </div>

    <div class="form-banner" *ngIf="offsiteConfig.banner_image_url && !isGoaTheme">
      <img [src]="offsiteConfig.banner_image_url" alt="Offsite {{ offsiteYear }} banner" class="form-banner-img">
    </div>

    <div class="form-content">
      <form [formGroup]="offsiteForm">

        <!-- AREA A: Key Information and Attendance Confirmation -->
        <div id="area-a" class="form-section area-a">
          <div class="section-header">
            <div class="section-number">1</div>
            <div>
              <h2 class="section-title">Employee Information</h2>
              <p class="section-subtitle">Your details are pre-filled from company records</p>
            </div>
          </div>
        
          <div class="info-section">
            <div class="info-notice">
              <div class="notice-icon">&#9432;</div>
              <ng-container *ngIf="isLoadingConfig">
                <p>Loading event details...</p>
              </ng-container>
              <ng-container *ngIf="!isLoadingConfig">
                <p>
                  Offsite {{ offsiteYear }} is re-scheduled to
                  <strong>{{ formatConfigDate(offsiteConfig.offsite_start) || 'TBD' }}</strong>
                  -
                  <strong>{{ formatConfigDate(offsiteConfig.offsite_end) || 'TBD' }}</strong>.
                  The event will be held at <strong>{{ offsiteConfig.form_location || 'TBD' }}</strong>.
                  This is a mandatory event for all eligible employees to foster team bonding and professional development.
                  Only once someone says “Yes, I will attend” then the rest of the sections 2,3,4 shall open.
                </p>
              </ng-container>
            </div>

            <div class="employee-info-grid" *ngIf="!isLoadingEmployeeData">
              <div class="info-item">
                <label>Employee Name</label>
                <span class="info-value">{{ employeeInfo.name || 'N/A' }}</span>
              </div>
              <div class="info-item">
                <label>Employee ID</label>
                <span class="info-value">{{ employeeInfo.code || 'N/A' }}</span>
              </div>
              <div class="info-item">
                <label>Email ID</label>
                <span class="info-value">{{ employeeInfo.email || 'N/A' }}</span>
              </div>
              <div class="info-item">
                <label>Contact Number</label>
                <span class="info-value">{{ employeeInfo.contact || 'N/A' }}</span>
              </div>
              <div class="info-item">
                <label>Department</label>
                <span class="info-value">{{ employeeInfo.department || 'N/A' }}</span>
              </div>
              <div class="info-item">
                <label>Gender</label>
                <span class="info-value">{{ employeeInfo.gender || 'N/A' }}</span>
              </div>
              <div class="info-item">
                <label>Company</label>
                <span class="info-value">{{ employeeInfo.company || 'N/A' }}</span>
              </div>
              <div class="info-item">
                <label>Category</label>
                <span class="info-value">{{ employeeInfo.category || 'N/A' }}</span>
              </div>
            </div>

            <div class="employee-info-grid loading-state" *ngIf="isLoadingEmployeeData">
              <div class="loading-message">
                <div class="loading-spinner"></div>
                <p>Loading employee information...</p>
              </div>
            </div>
          </div>

          <div class="section-divider"></div>

          <div class="attendance-section">
            <h3 class="subsection-title">Attendance Confirmation</h3>
            <div class="important-notice">
              <div class="notice-icon warning">!</div>
              <p>
                <strong>Please note:</strong> Selecting "Yes" indicates your availability for the <strong>entire duration</strong> of Offsite.
                If you select "No", an email from your HOD outlining the reason for your absence must be sent to Ms. Martina Yadav
                <br><br>
                Offsite {{ offsiteYear }} is intended to foster personal and professional engagement among colleagues. 
                Participation is limited to <strong>employees only</strong>. Spouses and children are not permitted to accompany on travel or to the Offsite location.
              </p>
            </div>

            <div class="attendance-buttons">
              <label class="question-label">I Hereby Confirm My Attendance For Offsite {{ offsiteYear }}:</label>
              <div class="button-group">
                <button 
                  type="button" 
                  class="attendance-btn" 
                  [class.selected]="offsiteForm.get('attendance')?.value === 'Yes'"
                  [disabled]="isFormReadOnly"
                  (click)="offsiteForm.patchValue({attendance: 'Yes'})">
                  &#10003;&nbsp; Yes, I will attend
                </button>
                <button 
                  type="button" 
                  class="attendance-btn no-btn" 
                  [class.selected]="offsiteForm.get('attendance')?.value === 'No'"
                  [disabled]="isFormReadOnly"
                  (click)="offsiteForm.patchValue({attendance: 'No'})">
                  &#10007;&nbsp; No, I cannot attend
                </button>
              </div>
              <div class="error-message" *ngIf="offsiteForm.get('attendance')?.touched && offsiteForm.get('attendance')?.invalid">
                Please confirm your attendance
              </div>
            </div>
          </div>
        </div>

        <!-- AREA B: Meal Preference and ID Upload (Conditional) -->
        <div id="area-b" class="form-section area-b" *ngIf="showAreaB">
          <div class="section-header">
            <div class="section-number">2</div>
            <div>
              <h2 class="section-title">Preferences &amp; Documents</h2>
              <p class="section-subtitle">Select your meal preference and upload ID</p>
            </div>
          </div>
          
          <!-- Meal Preference -->
          <div class="form-group">
            <label class="form-label required">Meal Preference</label>
            <mat-radio-group formControlName="mealPreference" class="radio-group-vertical">
              <mat-radio-button value="vegetarian">Vegetarian</mat-radio-button>
              <mat-radio-button value="vegetarian_eggs">Vegetarian plus Eggs</mat-radio-button>
              <mat-radio-button value="non_vegetarian">Non-vegetarian</mat-radio-button>
            </mat-radio-group>
            <div class="error-message" *ngIf="offsiteForm.get('mealPreference')?.touched && offsiteForm.get('mealPreference')?.invalid">
              Please select your meal preference
            </div>
          </div>

          <!-- Aadhar Number -->
          <div class="form-group">
            <label class="form-label required">Aadhar Card Number</label>
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Enter 12-digit Aadhar Number</mat-label>
              <input matInput formControlName="aadharNumber" placeholder="XXXX XXXX XXXX" maxlength="14" inputmode="numeric" (keypress)="onAadharKeypress($event)" (input)="onAadharInput($event)" (paste)="onAadharPaste($event)">
              <mat-error *ngIf="offsiteForm.get('aadharNumber')?.hasError('required')">
                Aadhar number is required
              </mat-error>
              <mat-error *ngIf="offsiteForm.get('aadharNumber')?.hasError('pattern')">
                Please enter a valid 12-digit Aadhar number
              </mat-error>
            </mat-form-field>
          </div>

          <div class="form-group">
            <label class="form-label required">Upload Aadhar Card (Both Sides)</label>
            <div class="upload-notice">
              <p>
                <strong>Important:</strong> In case your name in Aadhar is not same as in Gentari system, please write to amit.raturi@gentari.co.in.
                <br>
                Accepted formats: JPEG, PNG, or PDF only (Max 5MB per file). You can upload multiple files.
              </p>
            </div>
            
            <div class="file-upload-area">
              <input 
                type="file" 
                #fileInput 
                (change)="onFileSelect($event)" 
                accept=".jpg,.jpeg,.png,.pdf"
                multiple
                style="display: none">
              
              <div class="upload-box" *ngIf="!isFormReadOnly" (click)="fileInput.click()">
                <p>Click to upload or drag and drop</p>
                <span class="file-types">JPEG, PNG, PDF (max 5MB each) — Multiple files allowed</span>
              </div>

              <div class="uploaded-file" *ngFor="let f of uploadedFiles; let i = index; trackBy: trackByFile" [class.uploading]="f.uploading">
                <div class="file-preview">
                  <img *ngIf="f.fileType === 'image' && f.previewURL" [src]="f.previewURL" alt="Preview" class="preview-thumbnail">
                  <img *ngIf="f.fileType === 'image' && !f.previewURL && f.downloadURL" [src]="f.downloadURL" alt="Preview" class="preview-thumbnail">
                  <div *ngIf="f.fileType === 'pdf' || (!f.fileType && !f.previewURL)" class="preview-pdf">
                    <span>PDF</span>
                  </div>
                </div>
                <div class="file-info">
                  <span class="file-uploading-spinner" *ngIf="f.uploading"></span>
                  <span>{{ f.displayName }}</span>
                  <span class="file-status" *ngIf="f.uploading">Uploading...</span>
                  <span class="file-status uploaded" *ngIf="!f.uploading && f.downloadURL">&#10003; Uploaded</span>
                </div>
                <button type="button" class="remove-file-btn" (click)="removeFile(i)" [disabled]="f.uploading || isFormReadOnly" *ngIf="!isFormReadOnly">
                  &#10005;
                </button>
              </div>
            </div>
            <div class="error-message" *ngIf="offsiteForm.get('idDocument')?.touched && offsiteForm.get('idDocument')?.invalid">
              Please upload your Aadhar Card
            </div>
          </div>
        </div>

        <!-- AREA C: Room Allocation (Conditional) -->
        <div id="area-c" class="form-section area-c" *ngIf="showAreaC">
          <div class="section-header">
            <div class="section-number">3</div>
            <div>
              <h2 class="section-title">Room Allocation</h2>
              <p class="section-subtitle">Choose your preferred room arrangement</p>
            </div>
          </div>
          
          <div class="form-group">
            <label class="form-label required">Room Type</label>
            <mat-radio-group formControlName="roomAllocation" class="radio-group-vertical room-options">
              <mat-radio-button value="triple" class="room-option">
                <div class="room-details">
                  <span class="room-type">Triple Sharing</span>
                  <span class="room-price">No Charges</span>
                  <span class="room-note">Default option</span>
                </div>
              </mat-radio-button>
              <mat-radio-button value="double" class="room-option" *ngIf="showDoubleSharingOption">
                <div class="room-details">
                  <span class="room-type">Double Sharing</span>
                  <span class="room-price" *ngIf="doubleShareAmountDisplay">{{ doubleShareAmountDisplay }}</span>
                  <span class="room-note">Limited supply; first come first served</span>
                </div>
              </mat-radio-button>
              <mat-radio-button value="single" class="room-option" *ngIf="showSingleSharingOption">
                <div class="room-details">
                  <span class="room-type">Single Sharing</span>
                  <span class="room-price" *ngIf="singleShareAmountDisplay">{{ singleShareAmountDisplay }}</span>
                  <span class="room-note">Limited supply; first come first served</span>
                </div>
              </mat-radio-button>
            </mat-radio-group>

            <div class="allocation-process">
              <h4>Allocation Process:</h4>
              <ol>
                <li>If you have a preference for room partner(s), please write to Mr. Amit Raturi (amit.raturi@gentari.co.in) ONLY after mutual agreement with the selected partner(s) and copy them on the email.</li>
                <li>Requesting specific room partners or room types does not guarantee final allocation. The Admin Department reserves the right to finalize room assignments ({{ availableRoomTypesDisplay }}) based on logistical considerations.</li>
                <li *ngIf="paidSharingTypesDisplay">The cheques for {{ paidSharingTypesDisplay }} sharing must be submitted to Ms. Martina Yadav within 3 working days else you will be moved to triple sharing without further notice.</li>
                <li *ngIf="paidSharingTypesDisplay">Cheques shall be drawn in favor of your employment company.</li>
                <li *ngIf="paidSharingTypesDisplay"><strong>Important:</strong> Cheque once submitted will not be returned in any circumstances.</li>
              </ol>
            </div>
          </div>
        </div>

        <!-- AREA D: Travel Details (Conditional) -->
        <div id="area-d" class="form-section area-d" *ngIf="showAreaD">
          <div class="section-header">
            <div class="section-number">4</div>
            <div>
              <h2 class="section-title">Travel Details</h2>
              <p class="section-subtitle">Select your preferred departure and return cities</p>
            </div>
          </div>
          
          <div class="travel-notes">
            <h4>Important Notes:</h4>
            <ul>
              <li><strong>A.</strong> Cost of travel between your place and the selected departure or return city can be reimbursed as per Gentari policies with bills.</li>
              <li><strong>B.</strong> No cost of overnight halt at any intermediate station shall be reimbursed.</li>
              <li><strong>C.</strong> Once we reach {{ destinationCity }}, travel arrangements shall be made by Admin team from the arrival point to the hotel.</li>
              <li><strong>D.</strong> Admin team shall be final authority in deciding the mode of transportation (Airport/Railway/Bus/Cab) from your place to offsite and back.</li>
            </ul>
          </div>

          <div class="form-group">
            <label class="form-label required">Departure City Preference</label>
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Select City</mat-label>
              <mat-select formControlName="departureCity">
                <mat-option *ngFor="let city of cities; trackBy: trackByCity" [value]="city">
                  {{ city }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            
            <mat-form-field 
              appearance="outline" 
              class="full-width" 
              *ngIf="offsiteForm.get('departureCity')?.value === 'Other'">
              <mat-label>Enter City Name (Characters only)</mat-label>
              <input matInput formControlName="departureCityOther" placeholder="Enter city name">
              <mat-error *ngIf="offsiteForm.get('departureCityOther')?.hasError('pattern')">
                Only letters and spaces are allowed
              </mat-error>
            </mat-form-field>
            <div class="error-message" *ngIf="offsiteForm.get('departureCity')?.touched && offsiteForm.get('departureCity')?.invalid">
              Please select departure city
            </div>
          </div>

          <div class="form-group">
            <label class="form-label required">Return City Preference</label>
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Select City</mat-label>
              <mat-select formControlName="returnCity">
                <mat-option *ngFor="let city of cities; trackBy: trackByCity" [value]="city">
                  {{ city }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            
            <mat-form-field 
              appearance="outline" 
              class="full-width" 
              *ngIf="offsiteForm.get('returnCity')?.value === 'Other'">
              <mat-label>Enter City Name (Characters only)</mat-label>
              <input matInput formControlName="returnCityOther" placeholder="Enter city name">
              <mat-error *ngIf="offsiteForm.get('returnCityOther')?.hasError('pattern')">
                Only letters and spaces are allowed
              </mat-error>
            </mat-form-field>
            <div class="error-message" *ngIf="offsiteForm.get('returnCity')?.touched && offsiteForm.get('returnCity')?.invalid">
              Please select return city
            </div>
          </div>
        </div>

      </form>

      <!-- Form Actions -->
      <div class="submitted-banner" *ngIf="isSubmitted">
        <span class="submitted-icon">&#10003;</span>
        <span>Your registration has been submitted successfully.</span>
      </div>
      <div class="submitted-banner" *ngIf="timerExpired && !isSubmitted">
        <span class="submitted-icon">!</span>
        <span>The registration deadline has passed. This form is now read-only.</span>
      </div>

      <div class="form-actions" *ngIf="offsiteForm.get('attendance')?.value">
        <div class="actions-left">
          <span class="actions-hint" *ngIf="!isFormReadOnly">All fields marked with * are required</span>
          <span class="actions-hint submitted" *ngIf="timerExpired && !isSubmitted">Status: Deadline passed</span>
          <span class="actions-hint submitted" *ngIf="isSubmitted">Status: Submitted</span>
        </div>
        <div class="actions-right">
          <button 
            type="button" 
            class="btn btn-secondary" 
            (click)="saveMidway()"
            [disabled]="isSaving || isSubmitting || isFormReadOnly || isUploading">
            {{ isSaving ? 'Saving...' : 'Save Draft' }}
          </button>
          <button 
            type="button" 
            class="btn btn-primary" 
            (click)="submitForm()"
            [disabled]="isSaving || isSubmitting || isFormReadOnly || isUploading">
            {{ isSubmitting ? 'Submitting...' : (isSubmitted ? 'Submitted' : 'Submit Registration') }}
          </button>
        </div>
      </div>
    </div>
  </div>
  </ng-container>
</div>
